import React from 'react';

import { jakarta } from '@/lib/fonts';
import { cn } from '@/lib/utils';

export const Card = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        'p-8 rounded-3xl border border-[#e5e2f5] dark:border-neutral-800 bg-white dark:bg-neutral-900 shadow-xl shadow-[#301754]/5 hover:border-[#c02029]/30 transition-all duration-300 group',
        className
      )}
    >
      {children}
    </div>
  );
};

export const CardTitle = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <h3
      className={cn(
        jakarta.className,
        'text-xl font-bold text-[#2e1452] dark:text-white py-2 group-hover:text-[#c02029] transition-colors',
        className
      )}
    >
      {children}
    </h3>
  );
};

export const CardDescription = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p
      className={cn(
        'text-base font-normal text-[#5e5873] dark:text-neutral-300 max-w-sm leading-relaxed',
        className
      )}
    >
      {children}
    </p>
  );
};

export const CardSkeletonContainer = ({
  className,
  children,
  showGradient = true,
}: {
  className?: string;
  children: React.ReactNode;
  showGradient?: boolean;
}) => {
  return (
    <div
      className={cn(
        'h-[15rem] md:h-[20rem] rounded-2xl z-40',
        className,
        showGradient &&
          'bg-neutral-50 dark:bg-neutral-950 [mask-image:radial-gradient(50%_50%_at_50%_50%,white_0%,transparent_100%)]'
      )}
    >
      {children}
    </div>
  );
};
